<template>
  <section class="login_forget">
    <img src="~@/assets/img/login.jpg" class="login-img" height="100%" />
    <div class="form-box">
      <section class="container phonecode">
        <p class="hello">HELLO!</p>
        <p class="intro">欢迎您登录手护贝贝智能系统</p>
        <ElForm ref="form" :model="form" status-icon class="login-form">
          <ElFormItem label="手机号" prop="mobile">
            <ElInput v-model="form.mobile" type="number" auto-complete="off" />
          </ElFormItem>
          <ElFormItem class="verify" label="验证码">
            <ElInput
              v-model="form.verify"
              type="text"
              auto-complete="off"
              class="input-verify"
            /><ElButton class="btn-verify-code" @click="sendCode">{{
              timerCount > 0 ? timerCount + 's' : '获取验证码'
            }}</ElButton>
          </ElFormItem>
          <div class="account_login" @click="$router.push('/login')">
            账号密码登录
          </div>
          <ElFormItem>
            <ElButton
              class="submit_button"
              type="primary"
              :loading="loading"
              @click="submit"
              >登录</ElButton
            >
          </ElFormItem>
          <!-- <div class="forget_password" @click="$router.push('/reset-password')">
            忘记密码？去找回
          </div> -->
        </ElForm>
      </section>
    </div>
  </section>
</template>

<script>
import Cookie from 'js-cookie';
import {http, catchAppError} from '@/util';
import url from '@/config';

export default {
  data() {
    return {
      form: {
        mobile: '',
        verify: ''
      },
      loading: false,
      isTimer: false,
      timerCount: 0,
      timerId: 0
    };
  },
  methods: {
    timer() {
      this.isTimer = true;
      this.timerCount = 60;
      this.timerId = setInterval(() => {
        if (this.timerCount <= 0) {
          clearInterval(this.timer);
          return;
        }
        this.timerCount -= 1;
      }, 1000);
    },
    sendCode() {
      if (this.isTimer) {
        return;
      }

      http
        .post(url.sendMessage, {
          shop_phone: this.form.mobile
        })
        .then(() => {
          this.timer();
          this.$message({
            message: '发送成功',
            duration: 5000,
            type: 'success'
          });
        });
    },
    submit() {
      const {mobile, verify} = this.form;

      if (mobile < 10000000000 || mobile > 19999999999) {
        return this.$message.error('手机号格式错误，请重新输入');
      }

      if (!verify) {
        return this.$message.error('请输入验证码');
      }
      this.$http
        .post('/api/login/loginByPhone', {
          phone: mobile,
          code: verify,
          type: 2
        })
        .then(res => {
          Cookie.set('token', res.token);
          this.$router.push('/');
        })
        .catch(res => {
          this.$message.error(res.message);
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.phonecode {
  .el-button {
    &.btn-verify-code {
      width: 90px;
      padding: 0;
    }
  }
}
</style>

<style scoped>
/*
  el-input去掉自带上下箭头
*/
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
</style>

<style lang="scss">
.account_login {
  color: #4b90ff;
  position: absolute;
  right: 0;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
}

.forget_password {
  color: #999;
  text-align: center;
  &:hover {
    cursor: pointer;
  }
}

.login_forget {
  height: 100%;
  vertical-align: top;
  overflow: hidden;
  position: relative;
  .login-img {
    width: 93.5vh;
  }
  .form-box {
    position: absolute;
    left: 93.5vh;
    right: 0;
    top: 0;
    /* bottom: 0; */
    display: flex;
    align-items: center;
    justify-content: center;
    .el-input__inner {
      height: 44px;
      line-height: 44px;
      border-radius: 0;
      border-color: #b3b3b3;
    }
    .hello {
      margin-bottom: 30px;
      width: 400px;
      font-weight: bold;
      font-size: 30px;
    }
    .intro {
      margin-bottom: 20px;
      font-size: 20px;
    }
    .login-form,
    .hello,
    .intro {
      width: 400px;
      // margin-left: 70px;
    }
    .login-form {
      position: relative;
      .submit_button {
        margin-top: 10px;
        width: 100%;
        height: 50px;
        font-size: 16px;
        margin-top: 30px;
        background-color: #4b90ff;
        color: #fff;
      }
      .el-form-item__label {
        float: none;
        text-align: left;
      }
      .el-form-item__content {
        margin-left: 0 !important;
      }
      .verify {
        .input-verify {
          width: 227px;
          border-right: 0;
        }
        .el-button {
          display: inline-block;
          height: 44px;
          vertical-align: top;
          border: 1px solid #b3b3b3;
          border-left: 0;
          border-radius: 0;
        }
      }
    }
  }
}
</style>
